import { createTheme } from '@mui/material';
import { cyan, yellow } from '@mui/material/colors';
import { enUS, ptBR } from '@material-ui/core/locale';
import env from 'config/env';

const localeSel = (env.language === 'en' ? enUS : ptBR);

const DarkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: yellow[700],
      dark: yellow[800],
      light: yellow[500],
      contrastText: '#ffffff',
    },
    secondary: {
      main: cyan[500],
      dark: cyan[400],
      light: cyan[300],
      contrastText: '#ffffff',
    },
    background: {
      paper: '#303134',
      default: '#202124',
    },
  },
  typography: {
    allVariants: {
      color: 'white',
    }
  }
},
localeSel,
);

DarkTheme.components = {
  MuiAlert: {
    defaultProps: {
      variant: 'filled',
    },
  }
};

export type Theme = typeof DarkTheme;

export default DarkTheme;